import { LenderToLenderCrossPoolMeta, UserData } from '../utils/types'
import { getSiloV2UserDataConverter } from '../silo-v2/userCallParse'

export {
  SILO_V3_USER_CALLS_PER_SIDE,
  SILO_V3_USER_CALLS_PER_PAIR,
} from './userCallBuild'

/**
 * Silo v3 user data.
 *
 * The read set, the packed lens layout and every derived field are identical to
 * v2 — the only difference is which registry slot the roster is resolved from, and
 * `resolveSiloRoster` already branches on the lender key for that. So this is a
 * thin delegation rather than a copy: a second implementation would be two places
 * to fix the next time a field is added, and the versions have never differed in
 * anything the converter touches.
 */
export const getSiloV3UserDataConverter = (
  lender: string,
  chainId: string,
  account: string,
  meta?: LenderToLenderCrossPoolMeta,
  params?: any,
): [(data: any[]) => { [lender: string]: UserData } | undefined, number] =>
  getSiloV2UserDataConverter(lender, chainId, account, meta, params)
